/**
 * Analytics logging for single-order reassignment save.
 * @module reAssignModal/utils/logReassignSaveAnalytics
 */

import { ScreenNamesForBigQuery } from "../../../../enums/eventsData";
import { EventsName } from "../../../../enums/eventsName";
import { apiWorkerManager } from "../../../../workerManagers/workerManager";
import { ReassignModalProvider } from "../types";

/** Parameters for {@link logReassignSaveAnalytics}. */
export interface LogReassignSaveAnalyticsParams {
  /** Order being reassigned from the worklist row. */
  orderId: string;
  /** Patient id from assignee cell metadata. */
  patientId: string;
  /** Organization id for the analytics payload. */
  orgId: string;
  /** Authenticated user id. */
  userId: string;
  /** Authenticated user email. */
  userEmail: string;
  /** Provider document id before reassignment. */
  assignedToId?: string;
  /** Provider document id selected in the modal. */
  newProviderId: string;
  /** Full provider list used to resolve assignee email for analytics. */
  providersDetails: ReassignModalProvider[] | undefined;
}

/**
 * Enqueues the worklist assigned-to save analytics event.
 *
 * @param params - Order, user, and assignee context for the event payload
 */
export const logReassignSaveAnalytics = (
  params: LogReassignSaveAnalyticsParams,
): void => {
  const provider = params.providersDetails?.find(
    (entry) => entry.id === params.newProviderId,
  );

  apiWorkerManager.enqueueAndProcess({
    event_name: EventsName.ASSIGNED_TO_SAVE_CLICKED,
    patient_id: params.patientId,
    order_id: params.orderId,
    user_id: params.userId,
    user_email: params.userEmail,
    org_id: params.orgId,
    additional_data: {
      screen_name: ScreenNamesForBigQuery.WORKLIST,
      assigned_to: params.assignedToId,
      new_assigned_to: params.newProviderId,
      assignee_user_email:
        provider?.email || provider?.EmailAddresses?.[0] || "",
    },
  });
};
